import React from "react";
import { onPressInHaptic } from "widgets/src/onPressInHaptic";
import { TeamHeaderButton } from "./TeamHeaderButton";
import { ColorType } from "arkh";
import { useIntlTokens } from "../../../../../components/mobile/useIntlTokens";

export function TeamHeaderSettingsButton(props: {
  onPress: () => void;
  tintColor: ColorType;
  compact?: boolean;
}) {
  const intl_tokens = useIntlTokens();
  return (
    <TeamHeaderButton
      title={props.compact ? undefined : intl_tokens.Admin}
      icon="settings"
      spaceLeft={props.compact ? "small" : "medium"}
      spaceRight={props.compact ? "small" : "medium"}
      tintColor={props.tintColor}
      onPress={() => {
        props.onPress();
      }}
      onPressIn={onPressInHaptic}
    />
  );
}
